/** Presentation only: honor admin vehicle preferences without changing map visibility. */
type FleetPreferences = {
  vehicleId?: string; displayName?: string; driverName?: string; addressBookEntry?: string;
  samsaraAddress?: string; order?: number; blacklisted?: boolean;
  isMoving?: boolean; isEngineOff?: boolean;
};
export function selectFleetVehicles<T extends FleetPreferences>(vehicles: readonly T[], search: string): T[] {
  const query = search.trim().toLowerCase();
  return vehicles.filter(vehicle => !vehicle.blacklisted)
    .filter(vehicle => !query || [vehicle.displayName || vehicle.vehicleId || '', vehicle.driverName || vehicle.addressBookEntry || '', vehicle.samsaraAddress || '']
      .some(value => value.toLowerCase().includes(query)))
    .sort((a, b) => {
      // Movement takes priority; saved order applies independently within each group.
      const aMoving = Boolean(a.isMoving && !a.isEngineOff);
      const bMoving = Boolean(b.isMoving && !b.isEngineOff);
      if (aMoving !== bMoving) return aMoving ? -1 : 1;
      const aOrder = typeof a.order === 'number' && Number.isFinite(a.order) ? a.order : Infinity;
      const bOrder = typeof b.order === 'number' && Number.isFinite(b.order) ? b.order : Infinity;
      if (aOrder !== bOrder) return aOrder - bOrder;
      return (a.displayName || a.vehicleId || '').localeCompare(b.displayName || b.vehicleId || '');
    });
}
